module.exports = __webpack_public_path__ + "img/Pic_IONE_Girl.f6548172.png";